// @flow
import type {Element} from 'react'
import React, {Component} from 'react'
import {noop} from 'underscore'

import type {Path, UpdateCallback} from 'components/proposals/types'
import Item from 'components/proposals/Part/Item'
import Checkbox from 'components/ui/Inputs/Checkbox'

type Props = {
  id: ?string,
  isReadonly: boolean,
  item: Item,
  path: Path,
  onChange: UpdateCallback,
  tabIndex: number,
}

class SelectItem extends Component<Props> {
  static defaultProps: { id: null, isReadonly: boolean, onChange: any, tabIndex: number } = {
    id: null,
    isReadonly: false,
    onChange: noop,
    tabIndex: 0,
  }

  onChange: (() => void) = () => {
    this.props.onChange(
      this.props.path,
      this.selectItem.toggleSelected(),
    )
  }

  onKeyPress: ((event: SyntheticKeyboardEvent<>) => void) = (event: SyntheticKeyboardEvent<>) => {
    if (event.key === 'Enter')
      this.onChange()
  }

  get selectItem(): Item {
    return this.props.item
  }

  render(): Element<"div"> {
    return (
      <div id={this.props.id} className="refinery-select-items__checkbox">
        <Checkbox
          checked={this.selectItem.isSelected}
          disabled={this.props.isReadonly}
          label={this.selectItem.displayName}
          onChange={this.onChange}
          onKeyPress={this.onKeyPress}
          tabIndex={this.props.tabIndex}
        />
      </div>
    )
  }
}

export default SelectItem
